import React from "react";
import { routes } from "../constants/routes";

export default function Footer() {
  return (
    <React.Fragment>
      <footer className="new_footer_area bg_color">
        <div className="new_footer_top">
          <div className="container">
            <div className="row">
              <div className="col-lg-3 col-md-6">
                <div className="f_widget">
                  <p>
                    UK Head Office <br></br>Selsey Road, Donnington, West
                    Sussex, PO20 7PU <br></br>Postal address:<br></br> PO Box
                    486 Stroud Gloucestershire
                  </p>
                </div>
              </div>
              <div className="col-lg-3 col-md-6">
                <div className="f_widget-email second-br">
                  {/* <p>T: 01243 674270 </p>
                  <p className="short-text">
                    (strictly non-traders only call messaging service)
                  </p>
                  <p>Info@swallowevents.com</p>
                  <p className="short-text">
                    (strictly non-traders only please)
                  </p>
                  <p>Tradres@swallowevents.com</p>
                  <p className="short-text">
                   (strictly traders only please)
                  </p> */}
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href={routes.TERMS_CONDITION}
                  >
                    <p>Terms & Conditions</p>
                  </a>
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href={routes.PRIVACY_POLICY}
                  >
                    <p>Privacy Policy</p>
                  </a>
                  <a target="_blank" rel="noreferrer" href={routes.ABOUT_US}>
                    <p>About Us</p>
                  </a>
                  {/* <a target="_blank" rel="noreferrer" href={routes.EVENT_FAQ}>
                    <p>FAQ</p>
                  </a>

                  <a
                    href={routes.ADD_INQUIRY}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <p>Contact Us</p>
                  </a> */}
                </div>
              </div>
              <div className="col-lg-3 col-md-6 mrg-top">
                <div className="f_widget-email">
                  <p className="short-text2">Opening Hours</p>
                  <p className="short-text2">09:30 - 17:30</p>
                  <p className="short-text2">Monday - Friday</p>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 desktop-show">
                <div className="social-widget">
                  <div className="f_social_icon">
                    <a
                      href="https://www.facebook.com/swalloweventsuk"
                      className="fab fa-facebook"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {}
                    </a>
                    <a
                      href="https://twitter.com/swallow_events"
                      className="fab fa-twitter"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {}
                    </a>
                    <a
                      href="https://www.linkedin.com/company/swallow-events"
                      className="fab fa-linkedin"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {}
                    </a>
                    <a
                      href="https://www.instagram.com/swallow_events/"
                      className="fab fa-instagram"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {}
                    </a>
                  </div>
                </div>
                <div className="contact-button">
                  {/* <a
                    href={routes.ADD_INQUIRY}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    CONTACT US
                  </a> */}
                </div>
              </div>
              <div className="col-lg-3 col-md-6 mt-5">
                <div className="f_widget">
                  <p>
                    Australian Office 6 George Street Spotswood, Melbourne VIC
                    3015 Australia
                  </p>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 mt-5">
                <div className="f_widget-email second-br">
                  {/* <a
                    target="_blank"
                    rel="noreferrer"
                    href={routes.TERMS_CONDITION}
                  >
                    <p>Terms & Conditions</p>
                  </a>
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href={routes.PRIVACY_POLICY}
                  >
                    <p>Privacy Policy</p>
                  </a>
                  <a target="_blank" rel="noreferrer" href={routes.ABOUT_US}>
                    <p>About Us</p>
                  </a>*/}
                  <a target="_blank" rel="noreferrer" href={routes.EVENT_FAQ}>
                    <p>FAQ</p>
                  </a>

                  <a
                    href={routes.ADD_INQUIRY}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <p>Contact Us</p>
                  </a>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 mt-5">
                <div className="f_widget-email">
                  <p className="short-text2">Opening Hours</p>
                  <p className="short-text2">10:30 - 18:30</p>
                  <p className="short-text2">Monday - Friday</p>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 mt-5 mobile-show">
                <div className="social-widget">
                  <div className="f_social_icon">
                    <a href="!#" ><i className="fab fa-facebook"></i></a>
                    <a href="!#" ><i className="fab fa-twitter"></i></a>
                    <a href="!#" ><i className="fab fa-linkedin"></i></a>
                    <a href="!#" ><i className="fab fa-instagram"></i></a>
                  </div>
                </div>
                <div className="contact-button">
                  {/* <a
                    href={routes.ADD_INQUIRY}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    CONTACT US
                  </a> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </React.Fragment>
  );
}
